import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CodeAuthenticationComponent } from './code-authentication/code-authentication.component';
import { SelectOrganizationComponent } from './select-organization/select-organization.component';
import { TenantResolver } from './resolvers/tenant.resolver';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'authentication', component: CodeAuthenticationComponent },
  {
    path: 'select-organization',
    component: SelectOrganizationComponent,
    resolve: { tenants: TenantResolver },
    canActivate: [AuthGuard],
  },
];
